<template>
  <div>
    <div class="flex flex-wrap -mx-3" :class="order.status === 'Cancelled' ? 'opacity-50 pointer-events-none' : ''">
      <div class="w-full md:w-1/3 px-3">
        <div class="flex -mx-2">
          <div class="flex-grow px-2">
            <h3 class="mb-2 uppercase">{{ selectedOffice.network_id === 2 ? 'Marketing Pack' : 'Enhanced Marketing' }} '{{ order.pack.name }}'</h3>
            <p>Order number: {{ order.id }}</p>
            <p class="capitalize">{{ order.pack.delivery_type }} Delivery</p>

            <div class="text-xs text-grey-darker mt-6">
              <p>Ordered: {{ order.ordered_at | date }}</p>
              <div v-for="payment in order.payments" :key="payment.id">
                <p v-if="payment && payment.paid_at">
                  {{ paymentLabel(payment) }} of {{ payment.amount | gbp }} received at: {{ payment.paid_at | datetime }}
                </p>
                <p v-else-if="payment">
                  <strong>{{ paymentLabel(payment) }} of {{ payment.amount | gbp }} pending</strong>
                </p>
              </div>
              <p v-if="order.edition_number && order.edition_number !== 'TBD'">
                Refined Magazine: {{ order.edition_number}}.
              </p>
              <p v-if="order.delivery_date && order.delivery_date !== 'TBD'">
                Estimated delivery date: {{order.delivery_date}}.
              </p>
            </div>
          </div>

          <div class="flex-shrink px-2">
            <gauge-graph :series="[{ color: '#eee', value: 100.9 },{ color: '#1f9d55', value: totalProgressPercentage }]" :maximum="101" :arc-size="360" :offset="0" class="w-24 mb-3">
              <p slot="text" class="text-lg text-green-dark">{{ totalProgressPercentage }}%</p>
            </gauge-graph>
          </div>
        </div>

        <hr class="w-full border-b border-grey-light my-6" />
        <h4 class="mb-2 text-sm">Property:</h4>
        <div class="mb-6">
          <p>{{ order.address }}</p>
          <p class="text-xs text-grey-darker">
            <span v-if="order.bedrooms">{{ order.bedrooms }} {{ order.bedrooms === 1 ? 'Bedroom' : 'Bedrooms' }} | </span>
            <span v-if="order.bathrooms">{{ order.bathrooms }} {{ order.bathrooms === 1 ? 'Bathroom' : 'Bathrooms' }} | </span>
            <span v-if="order.reception_rooms">{{ order.reception_rooms }} {{ order.reception_rooms === 1 ? 'Reception Room' : 'Reception Rooms' }} | </span>
            <span class="block">{{ order.price_qualifier }} {{ order.guide_price | gbp }}</span>
            <span v-if="order.tenure" class="block">Tenure: {{ order.tenure }}</span>
            <span v-if="order.council_tax_band" class="block">Council Tax Band: {{ order.council_tax_band }}</span>
          </p>
        </div>

        <h4 class="mb-2 text-sm">Vendor:</h4>
        <div class="mb-6">
          <p>{{ order.vendor1.name }}</p>
          <p>{{ order.vendor1.phone }}</p>
          <p>{{ order.vendor1.email }}</p>
        </div>

        <div class="mb-6" v-if="order.vendor2">
          <p>{{ order.vendor2.name }}</p>
          <p>{{ order.vendor2.phone }}</p>
          <p>{{ order.vendor2.email }}</p>
        </div>

        <h4 class="mb-2 text-sm">Notifications:</h4>
        <h5 class="text-xs">Main Contact:</h5>
        <div v-if="order.payment_type_id === 3" class="mb-2">
          <p>{{ order.associate.name }} ({{ order.associate.email }})</p>
        </div>
        <h5 v-if="order.payment_type_id === 3" class="text-xs">Order Placed By:</h5>
        <div class="mb-6">
          <p>{{ order.ordered_by.name }} ({{ order.ordered_by.email }})</p>
        </div>

        <div v-if="order.notification_cc.length > 0">
          <h5 class="text-xs">Additional Contacts:</h5>
          <div class="mb-6">
            <ul class="list-reset">
              <li v-for="(contact, i) in order.notification_cc" :key="i">
                {{ contact }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="w-full md:w-2/3 px-3 border-l pl-6">
        <div :class="{'opacity-25 pointer-events-none' : ![4,5,6,7,8,9,10].includes(order.status_id)}">
          <h3 class="mb-2 uppercase">Source Material</h3>
          <div class="overflow-auto px-1">
            <table class="table-auto text-center w-full">
              <thead class="uppercase text-xs">
                <tr>
                  <th class="text-left p-2 whitespace-no-wrap">
                    Product
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Fulfillment
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Scheduled
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Completed
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Status
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Upload
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Download
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-t border-grey-lighter" :class="{' bg-red-lightest': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' bg-yellow-lightest': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id)}" v-for="item in sourceMaterial" :key="item.id">
                  <td class="p-2 text-left border-l-4" :class="{' border-red-dark': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' border-yellow-dark': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id), ' border-green-dark': item.status == 'complete'}">
                    {{ item.name }}
                  </td>
                  <td class="p-2">
                    {{ item.fulfillment_by }}
                    <span v-if="item.fulfillment_by_id === 2">(Order No: {{ item.ehouse_order_id }})</span>
                    <span v-if="item.fulfillment_by_id === 7">(Order No: {{ item.focal_agent_order_id }})</span>
                  </td>
                  <td class="p-2">
                    <span v-if="!item.requires_scheduling">N/A</span>
                    <span v-else-if="item.scheduled_at">{{ item.scheduled_at | datetime(false) }}</span>
                    <button v-else-if="item.fulfillment_by_id === 2" type="button" class="w-full bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white p-2 text-xs border border-tertiary hover:border-transparent rounded shadow" @click="eHouseBookVisitInit(item)">Book eHouse Appointment</button>
                    <button v-else-if="item.fulfillment_by_id === 0 && !item.scheduled_at" type="button" class="w-full bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white p-2 text-xs border border-tertiary hover:border-transparent rounded shadow" @click="schedulingAgentItem = item">Schedule</button>
                    <span v-else>-</span>
                    <button v-if="item.fulfillment_by_id === 2 && item.can_unschedule && item.scheduled_at && !item.completed_at" type="button" class="w-full bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white p-2 text-xs border border-tertiary hover:border-transparent rounded shadow mt-2" @click="confirmCancelEhouse = item.id">Cancel Appointment</button>
                  </td>
                  <td class="p-2">
                    <span v-if="item.completed_at" class="text-green-dark">{{ item.completed_at | datetime }}</span>
                    <span v-else>-</span>
                    <button v-if="item.fulfillment_by_id === 2 && item.completed_at && [4,5].includes(order.status_id)" @click="ehouseAmendsItem = item" type="button" class="w-full bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white p-2 text-xs border border-tertiary hover:border-transparent rounded shadow mt-2">Request Amends</button>
                  </td>
                  <td class="p-2">
                    <span v-if="item.fulfillment_by_id === 0 && !item.required_for_artwork">N/A</span>
                    <i class="fas fa-hourglass-half" v-else-if="item.requires_scheduling && item.scheduled_at === null" title="Needs Scheduling"></i>
                    <i class="far fa-clock text-red-dark" v-else-if="item.completed_at === null" title="Awaiting Fulfillment"></i>
                    <i class="fas fa-check text-green-dark" v-else title="Complete"></i>
                  </td>
                  <td class="p-2">
                    <i class="fas fa-upload cursor-pointer" v-if="((item.fulfillment_by_id === 4 && item.attachments.length > 0) || (item.fulfillment_by_id === 0 && ([4,5].includes(order.status_id) || item.attachments.length === 0))) && (!item.requires_scheduling || item.scheduled_at)" @click="fulfillingAgentItem = item"></i>
                    <span v-else>-</span>
                  </td>
                  <td class="p-2 border-r-4" :class="{' border-red-dark': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' border-yellow-dark': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id), ' border-green-dark': item.status == 'complete'}">
                    <i class="fas fa-download cursor-pointer text-blue hover:text-blue-dark" v-if="item.attachments.length || (item.internal_type_id === 5 && item.completed_at)" @click="downloadAssetsItem = item"></i>
                    <i class="fas fa-ban text-grey" v-else></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex justify-end my-3">
            <button type="button" class="py-3 px-6 bg-black text-white rounded mr-3" v-if="photoAttachments.length > 35 && ![7, 8].includes(order.status_id) && selectedOffice.network_id === 7" @click="selectingPreferredPhotos = true">
              <i class="fas fa-images"></i> Select Preferred Photos
            </button>

            <button type="button" class="py-3 px-6 bg-black text-white rounded" v-if="assetCount" @click="downloadAssetBundleModalOpen = true">
              <span><i class="fas fa-download"></i> Download Assets</span>
            </button>
          </div>
        </div>

        <div :class="{'opacity-25 pointer-events-none' : ![5, 6, 7, 8, 9, 10, 11].includes(order.status_id)}">
          <div class="flex items-center flex-col my-6" v-if="order.vendor_source_material_approved_at">
            <span class="text-green-dark">
            <i class="flex rounded-full mx-auto border mb-2 border-green-dark w-8 h-8 items-center justify-center">
              <i class="fas fa-check"></i>
            </i>
            Source Material Approved by Vendor
            </span>
          </div>

          <div v-else>
            <p class="text-center my-6" v-if="hasStudioArtworkItems">We require vendor approval on the source material before the studio can start the artwork to avoid duplication of work. 5 sets of amends are allocated to each piece of artwork, subsequent changes will be charged at discounted artwork rate.</p>
            <p class="text-center my-6" v-if="order.status_id === 5">
              ‘Vendor Approval page’ <a :href="order.vendor_approval_url" target="_blank" class="text-blue">[Link]</a>
            </p>
            <div class="flex justify-center mb-6">
              <button type="button" class="py-3 px-6 bg-black text-white rounded" @click="vendorApprovalModalOpen = true">
                <i class="far fa-paper-plane mr-1"></i> Send for Vendor Approval
              </button>
            </div>

            <div class="w-full flex justify-center items-center -mx-3 mb-6">
              <div class="px-3">
                <input type="checkbox" id="sourceMaterialConfirmed" v-model="sourceMaterialConfirmed" />
                <label for="sourceMaterialConfirmed" class="whitespace-normal">I confirm the vendor has approved the source material for use in the artwork</label>
              </div>
              <div class="px-3">
                <button type="button" class="p-3 bg-black text-white rounded" :class="sourceMaterialConfirmed ? 'bg-black' : 'bg-grey'" @click="approveSourceMaterial">
                  <i class="far fa-check-circle mr-1"></i> Submit
                </button>
              </div>
            </div>
          </div>
        </div>

        <div :class="{'opacity-25 pointer-events-none' : ![6, 7, 8, 9, 10, 11].includes(order.status_id)}">
          <h3 class="mb-2 uppercase">Artwork</h3>
          <div class="overflow-auto px-1">
            <table class="table-auto text-center w-full mb-6">
              <thead class="uppercase text-xs">
                <tr>
                  <th class="text-left p-2 whitespace-no-wrap">
                    Product
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Fulfillment
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Scheduled
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Completed
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Status
                  </th>
                  <th class="p-2 whitespace-no-wrap">
                    Download
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-t border-grey-lighter" :class="{' bg-red-lightest': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' bg-yellow-lightest': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id)}" v-for="item in artwork" :key="item.id">
                  <td class="p-2 text-left border-l-4" :class="{' border-red-dark': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' border-yellow-dark': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id), ' border-green-dark': item.status == 'complete'}">{{ item.name }}<br>
                    <span v-if="item.data">
                      <small class="text-grey-dark" v-if="item.data.name">
                        {{ item.data.name }}
                      </small>
                      <small class="text-grey-dark" v-if="item.data.style">
                        ({{ item.data.style }})
                      </small>
                      <small class="text-grey-dark" v-if="item.data.copies">
                        {{ item.data.copies }} {{ item.data.copies === 1 ? 'Copy' : 'Copies' }}
                      </small>
                      <small class="text-grey-dark" v-if="item.data.additional_copies">
                        - +{{ item.data.additional_copies }} additional copies
                      </small>
                      <small class="text-grey-dark" v-if="item.data.location_maps_included">
                        - Location Maps Included
                      </small>
                      <small class="text-grey-dark" v-if="item.data.double_page_spread">
                        (Double Page Spread Upgrade)
                      </small>
                    </span>
                  </td>
                  <td class="p-2">{{ item.fulfillment_by }}</td>
                  <td class="p-2">
                    <span v-if="!item.requires_scheduling">N/A</span>
                    <span v-else-if="item.scheduled_at">{{ item.scheduled_at | datetime(false) }}</span>
                    <span v-else>-</span>
                  </td>
                  <td class="p-2">
                    <span v-if="item.completed_at" class="text-green-dark">{{ item.completed_at | datetime }}</span>
                    <span v-else>-</span>
                  </td>
                  <td class="p-2">
                    <i class="fas fa-hourglass-start" v-if="item.requires_scheduling && item.scheduled_at === null" title="Needs Scheduling"></i>
                    <i class="fas fa-hourglass-end" v-else-if="!item.attachments.length && !item.approved_at" title="Awaiting Proof"></i>
                    <i class="fas fa-hourglass-end" v-else-if="item.attachments.length && !item.approved_at" title="Requires Agent Approval"></i>
                    <i class="fas fa-check text-green-dark" v-else-if="item.completed_at === null" title="Approved"></i>
                    <i class="fas fa-check text-green-dark" v-else title="Complete"></i>
                  </td>
                  <td class="p-2">
                    <a v-if="item.attachments.length" :href="item.attachments[0].url" target="_blank" class="text-blue hover:text-blue-dark cursor-pointer">
                      <i class="fas fa-download"></i>
                    </a>
                    <i class="fas fa-ban text-grey" v-else></i>
                  </td>
                  <td class="p-2 border-r-4 text-right" :class="{' border-red-dark': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' border-yellow-dark': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id), ' border-green-dark': item.status == 'complete'}">
                    <template v-if="item.fulfillment_by_id === 8 && !item.completed_at">
                      <a v-if="item.mmn_order_id && !item.completed_at" class="rounded p-2 whitespace-no-wrap no-underline bg-green-dark hover:bg-green text-white" :href="getDigitalHubUrl(item)" target="_blank">
                        <i class="fas fa-arrow-right"></i> Create
                      </a>
                      <button v-else type="button" class="rounded p-2 whitespace-no-wrap no-underline bg-grey-light text-grey-darker cursor-not-allowed" title="Creating draft order. Please check back shortly.">
                        <i class="fas fa-arrow-right"></i> Create
                      </button>
                    </template>
                    <template v-else-if="item.attachments.length && order.status_id === 6">
                      <button class="rounded bg-green-dark hover:bg-green text-white p-2 whitespace-no-wrap" v-if="!item.approved_at" @click="artworkApprovalItem = item">
                        <i class="fas fa-check-circle"></i> Approve
                      </button>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <h3 class="mb-2 uppercase mt-12">Other Fulfillment</h3>
        <div class="overflow-auto px-1">
          <table class="table-auto text-center w-full mb-6">
            <thead class="uppercase text-xs">
              <tr>
                <th class="text-left p-2 whitespace-no-wrap">
                  Product
                </th>
                <th class="p-2 whitespace-no-wrap">
                  Fulfillment
                </th>
                <th class="p-2 whitespace-no-wrap">
                  Scheduled
                </th>
                <th class="p-2 whitespace-no-wrap">
                  Completed
                </th>
                <th class="p-2 whitespace-no-wrap">
                  Status
                </th>
                <th class="p-2 whitespace-no-wrap">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-t border-grey-lighter" :class="{' bg-red-lightest': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' bg-yellow-lightest': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id)}" v-for="item in otherItems" :key="item.id">
                <td class="p-2 text-left border-l-4" :class="{' border-red-dark': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' border-yellow-dark': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id), ' border-green-dark': item.status == 'complete'}">{{ item.name }}</td>
                <td class="p-2">{{ item.fulfillment_by }}</td>
                <td class="p-2">
                  <span v-if="!item.requires_scheduling">N/A</span>
                  <span v-else-if="item.scheduled_at">{{ item.scheduled_at | datetime(false) }}</span>
                  <span v-else>-</span>
                </td>
                <td class="p-2">
                  <span v-if="item.completed_at" class="text-green-dark">{{ item.completed_at | datetime }}</span>
                  <span v-else>-</span>
                </td>
                <td class="p-2">
                  <i class="fas fa-hourglass-half" v-if="item.requires_scheduling && item.scheduled_at === null" title="Needs Scheduling"></i>
                  <i class="far fa-clock text-red-dark" v-else-if="item.completed_at === null" title="Awaiting Fulfillment"></i>
                  <i class="fas fa-check text-green-dark" v-else title="Complete"></i>
                </td>
                <td class="p-2 border-r-4" :class="{' border-red-dark': item.status == 'awaiting_schedule' && [0, 2].includes(item.fulfillment_by_id), ' border-yellow-dark': item.status == 'awaiting_schedule' && ![0, 2].includes(item.fulfillment_by_id), ' border-green-dark': item.status == 'complete'}">
                  <a v-if="item.internal_type_id === 14" :href="item.page_turner ? item.page_turner.url : null" target="_blank" :class="item.page_turner && item.page_turner.status_id === 3 ? 'bg-green-dark hover:bg-green text-white' : 'bg-grey-light text-grey-darker pointer-events-none cursor-not-allowed'" class="rounded p-2 whitespace-no-wrap no-underline">
                    <i class="fas fa-arrow-right"></i> View
                  </a>
                  <a v-else-if="item.internal_type_id === 22" :href="`${apiUrl}/login/propertybox/${item.id}`" target="_blank" :class="item.data.workspace_url ? 'bg-green-dark hover:bg-green text-white' : 'bg-grey-light text-grey-darker pointer-events-none cursor-not-allowed'" class="rounded p-2 whitespace-no-wrap no-underline">
                    <i class="fas fa-arrow-right"></i> Create
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="order.status_id != 10">
          <h3 class="mb-2 uppercase">Contact Us</h3>
          <p class="mb-3" v-if="hasStudioArtworkItems"><em>For anything related to the artwork section of your order, please contact the Fine & Country Studio. For all other queries, please contact the Fine & Country Support Team.</em></p>
          <select v-model="contact.help_desk" class="border hover:border-grey-darker p-3 mb-3">
            <option :value="null">Please Select</option>
            <option value="studio" v-if="showStudioOption">Fine & Country Studio (020 3096 5444)</option>
            <option v-if="selectedOffice.network_id === 7" value="cst">Fine & Country Support Team (020 3368 8709)</option>
            <option v-else-if="selectedOffice.network_id === 2" value="cst">Guild Support Team (020 3368 6878)</option>
          </select>
          <textarea v-model="contact.message" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" rows="6"></textarea>
          <p class="mt-2">Attachment: <input type="file" @change="contact.files = $event.target.files" multiple /></p>
          <div class="flex justify-end mt-2">
            <button type="button" class="p-3 bg-black text-white rounded" :class="{'opacity-25': contact.help_desk === null}" :disabled="contact.help_desk === null" @click="sendEnquiry">
              <i class="fas fa-sync fa-fw fa-spin" v-if="sendingEnquiry"></i>
              <span v-else>Send Enquiry</span>
            </button>
          </div>
        </div>

        <h3 class="mb-2 uppercase mt-6">Internal Notes</h3>
        <loader v-if="internalNotes === null" />
        <div v-else>
          <p v-if="internalNotes.length === 0" class="mb-3">
            There are no internal notes on this order.
          </p>
          <div v-else>
            <div v-for="note in internalNotes" :key="note.id" class="border p-3 mb-3" :class="{'bg-yellow-lighter': checkIfPrivateNote(note)}">
              <div class="flex -mx-2">
                <div class="w-20 px-2">
                  <img v-if="note.user.small_photo_url" :src="note.user.small_photo_url" loading="lazy" class="w-16 h-16 rounded-full object-cover" />
                  <div v-else>
                    <div class="w-16 h-16 rounded-full flex items-center justify-center bg-grey-light text-grey-dark text-lg">
                      <i class="fas fa-user"></i>
                    </div>
                  </div>
                </div>
                <div class="flex-1 px-2">
                  <div class="flex -mx-2">
                    <div class="flex-1 px-2">
                      <strong>{{ note.user.first_name }} {{ note.user.surname }}</strong>
                      <span class="bg-blue text-white rounded-full px-2 text-xs ml-2" v-if="[1,2].includes(note.user.type)">ADMIN</span>
                      <span class="bg-blue text-white rounded-full px-2 text-xs ml-2" v-else-if="note.user.type === 7">INTERVIEWER</span>
                      <em class="block mb-3">{{ note.created_at | datetime }}<span v-if="note.private"> - Private note</span></em>
                      <div v-if="note.show_admin || note.show_interviewer" class="flex mb-3">
                        <small class="mr-1">Sent To: </small>
                        <small v-if="note.show_admin">{{ selectedOffice.network_id === 2 ? 'support@guildproperty.co.uk' : 'support@fineandcountry.com' }}</small>
                        <small v-if="note.show_interviewer && note.show_admin" class="mr-1">,</small>
                        <small v-if="note.show_interviewer && note.interviewer_user_id">{{note.interviewer.email}}</small>
                        <small v-else-if="note.show_interviewer">{{order.interviewer.email}}</small>
                    </div>
                    </div>
                    <div class="px-2" v-if="note.user_id === profile.id">
                      <i class="fas fa-trash-alt cursor-pointer hover:text-red-dark" title="Delete Note" @click="deleteNote(note)"></i>
                    </div>
                  </div>
                  <p class="whitespace-pre-line">{{ note.body }}</p>
                </div>
              </div>
            </div>
          </div>

          <h4 class="mb-2 uppercase">Add Note</h4>
          <textarea v-model="internalNoteForm.body" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" rows="6"></textarea>
          <div class="mt-3">
            <p class="mb-1 font-bold">* ‘Internal Note’ unless tick boxes are selected below</p>
            <div class="flex">
              <div v-if="hasVendorInterview">
                <input type="checkbox" id="note_interviewer" v-model="internalNoteForm.show_interviewer" />
                <label for="note_interviewer" class="mr-12">Share note with Interviewer</label>
              </div>
              <div>
                <input type="checkbox" id="note_show_admin" v-model="internalNoteForm.show_admin" />
                <label for="note_show_admin" class="mr-12">Share note with support team.</label>
              </div>
            </div>
          </div>

          <div class="flex justify-end mt-2">
            <button type="button" class="p-3 bg-black text-white rounded" @click="addNote">
              <i class="fas fa-sync fa-fw fa-spin" v-if="savingInternalNote"></i>
              <span v-else>Save Note</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <modal
      v-if="schedulingEhouse !== null"
      @leave="schedulingEhouse = null"
      :showCloseBtn="true"
    >
      <loader v-if="ehousePhotographerTimeslots === null || ehouseBookingTimeslot" />
      <div v-else-if="ehousePhotographerTimeslots.length === 0">
        <h3 class="mb-2">No Available Timeslots</h3>
      </div>
      <div v-else>
        <h3 class="mb-2">Select a Photographer</h3>
        <p class="mb-6">Select a timeslot where the vendor will be available for eHouse to carry out their tasks at the property.</p>

        <label class="block mt-6">Timeslot:</label>
        <select v-model="selectedEhouseTimeslot" class="bg-white border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm">
          <option :value="null">[Please Select]</option>
          <option v-for="(timeslot, i) in ehousePhotographerTimeslots" :key="i" :value="timeslot">{{ timeslot.start | datetime(false) }} - {{ timeslot.photographerName }}</option>
        </select>

        <label class="block mt-6">Notes for the photographer:</label>
        <textarea v-model="ehousePhotographerNotes" class="block w-full bg-white border hover:border-grey focus:border-grey-dark p-2 mt-2 text-sm" rows="5"></textarea>

        <div class="flex justify-center mt-6" v-if="selectedEhouseTimeslot" @click="ehouseBookPhotographer">
          <button type="button" class="py-3 px-6 bg-black text-white rounded">
            <i class="far fa-check-circle mr-1"></i> Book timeslot
          </button>
        </div>
      </div>

      <div v-if="!(ehousePhotographerTimeslots === null || ehouseBookingTimeslot)" class="mt-6 bg-grey-lighter rounded p-3">
        <p class="mb-3">ehouse order number: {{ schedulingEhouse.ehouse_order_id }}</p>
        <p class="mb-3">For any booking-related queries, such as where an appointment time is not available, please call ehouse on 020&nbsp;8451&nbsp;8611 or email <a :href="`mailto:bookings@ehouse.co.uk?subject=Booking enquiry for order ${ schedulingEhouse.ehouse_order_id }`">bookings@ehouse.co.uk</a>.</p>
        <p>Please note ehouse office opening hours are 9am to 6pm, Mondays to Fridays.</p>
      </div>
    </modal>

    <deletion-modal
      v-if="confirmCancelEhouse !== null"
      :loading="cancellingEhouse"
      @confirmed="ehouseCancelPhotographer"
      @leave="confirmCancelEhouse = null"
      @dismissed="confirmCancelEhouse = null"
      confirm-label="Yes, cancel it.">
      <p class="text-center">Are you sure you wish to cancel this appointment with eHouse?</p>
    </deletion-modal>

    <modal
      v-if="schedulingAgentItem"
      @leave="schedulingAgentItem = null"
      :showCloseBtn="true"
    >
      <h3 class="mb-2">Schedule Work - {{ schedulingAgentItem.name }}</h3>
      <p class="mb-6">To help us keep track of your order, please schedule time to complete this item.</p>
      <date-time-picker v-model="schedulingAgentItem.scheduled_at" @close="scheduleAgentItem" :minute-step="15" format="dd/MM/yyyy HH:mm" class="inline-block bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm">
        <template slot="date">
          <button class="bg-primary rounded py-2 px-4 text-white">
            <i class="fas fa-arrow-left"></i> Set Date
          </button>
        </template>
        <template slot="time">
          <button class="bg-primary rounded py-2 px-4 text-white">
            Set Time <i class="fas fa-arrow-right"></i>
          </button>
        </template>
      </date-time-picker>
    </modal>

    <modal
      v-if="fulfillingAgentItem"
      @leave="fulfillingAgentItem = null"
      :showCloseBtn="true"
    >
      <template v-if="fulfillingAgentItem.internal_type_id === 21">
        <h3 class="mb-2">Property Description</h3>

        <textarea v-model="fulfillingAgentItem.data.description" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 text-sm mb-3" rows="14"></textarea>

        <div class="flex justify-end mt-6">
          <button class="bg-primary rounded px-6 py-3 text-white" @click="savePropertyDescription(fulfillingAgentItem)">
            Save
          </button>
        </div>
      </template>

      <template v-else>
        <h3 class="mb-2">Upload Files - {{ fulfillingAgentItem.name }}</h3>
        <table v-if="fulfillingAgentItem.uploads" class="w-full">
          <tbody>
            <tr v-for="(file, i) in fulfillingAgentItem.uploads" :key="i" class="h-8">
              <td class="w-full">{{ file.filename }}</td>
              <td>
                <i v-if="file.complete" class="fas fa-check-circle text-green-dark fa-2x"></i>
                <gauge-graph v-else :series="[{ color: '#eee', value: 101 },{ color: '#0d9eff', value: file.progress }]" :maximum="101" :arc-size="360" :offset="0" class="w-8 h-8">
                </gauge-graph>
              </td>
            </tr>
          </tbody>
        </table>
        <upload-dropzone @change="uploadAssets(fulfillingAgentItem, $event)" :accept="fulfillingAgentItem.attachment_validation" />
      </template>
    </modal>

    <modal
      v-if="downloadAssetsItem"
      @leave="downloadAssetsItem = null; galleryIndex = 0"
      :showCloseBtn="true"
    >
      <h3 class="mb-2">Download Assets</h3>
      <p class="mb-6">{{ downloadAssetsItem.name }}</p>
      <div v-if="galleryImages.length">
        <div class="flex items-center">
          <i class="fas fa-angle-left cursor-pointer fa-2x" v-if="galleryIndex > 0 && galleryImages.length > 1" @click="galleryIndex--" title="Previous"></i>
          <div class="mx-6 flex flex-col items-center">
            <img class="max-w-full shadow-md" :src="galleryImages[galleryIndex].url" />

            <p class="truncate my-6">{{ galleryImages[galleryIndex].filename }}</p>

            <div class="flex items-center mb-3">
              <template v-if="selectedOffice.network_id === 2 && [11, 16, 17].includes(downloadAssetsItem.internal_type_id)">
                <label class="mr-1">Tag:</label>
                <select v-model="galleryImages[galleryIndex].tag" @change="updateTag(downloadAssetsItem.id, galleryImages[galleryIndex])" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 text-sm mr-3">
                  <option :value="null">Other</option>
                  <option v-for="option in aiImageTags" :key="option.id" :value="option.id">
                    {{ option.name }}
                  </option>
                </select>
              </template>

              <a :href="galleryImages[galleryIndex].url" download target="_blank" class="block rounded mr-3 p-3 bg-grey-lighter hover:bg-grey-light text-left text-black no-underline whitespace-no-wrap">
                <i class="fas fa-download"></i> Download
              </a>
              <button type="button" class="bg-red-dark hover:bg-red-darker text-white p-3 rounded whitespace-no-wrap" title="Delete Asset" @click="attachmentDeleteItem = {item: downloadAssetsItem, attachment: galleryImages[galleryIndex]}">
                <i class="fas fa-trash-alt fa-fw"></i> Delete
              </button>
            </div>
          </div>
          <i class="fas fa-angle-right cursor-pointer fa-2x" v-if="galleryIndex < galleryImages.length - 1 && galleryImages.length > 1" @click="galleryIndex++" title="Next"></i>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2" v-if="galleryFiles.length">
        <div class="w-full md:w-1/2 px-2" v-for="(attachment, i) in galleryFiles" :key="i">
          <div class="flex items-stretch mb-3">
            <a :href="attachment.url" download target="_blank" class="block w-full rounded-l p-3 bg-grey-lighter hover:bg-grey-light text-left text-black no-underline truncate">
              <i class="fas fa-download"></i> {{ attachment.filename }}
            </a>
            <button type="button" class="bg-red-dark hover:bg-red-darker text-white p-3 rounded-r" title="Delete Asset" @click="attachmentDeleteItem = {item: downloadAssetsItem, attachment: attachment}">
              <i class="fas fa-trash-alt fa-fw"></i>
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal
      v-if="ehouseAmendsItem"
      @leave="ehouseAmendsItem = null"
      :showCloseBtn="true"
    >
      <h3 class="mb-2">{{ ehouseAmendsItem.name }}: Request Amends</h3>
      <p>
        Please contact ehouse at
        <a :href="`mailto:floorplans@ehouse.co.uk?subject=Amends for order ${ehouseAmendsItem.ehouse_order_id}`" v-if="ehouseAmendsItem.ehouse_type_id === 1">floorplans@ehouse.co.uk</a>
        <a :href="`mailto:eimages@ehouse.co.uk?subject=Amends for order ${ehouseAmendsItem.ehouse_order_id}`" v-else>eimages@ehouse.co.uk</a>
        to request amends quoting order number {{ ehouseAmendsItem.ehouse_order_id }}
      </p>
    </modal>

    <modal
      v-if="selectingPreferredPhotos"
      @leave="selectingPreferredPhotos = false"
      :showCloseBtn="true"
    >
      <h3 class="mb-2">Select Your Preferred Photos</h3>
      <div class="flex border-solid border-b-2 mb-2">
        <div class="w-full">
          <p class="mb-4">Please select your top 35 photos for use in the marketing materials.</p>
        </div>
        <div class="content-end w-1/2">
          <div class="ml-10"><i class="fas fa-star fa-lg text-yellow"></i> <span> = Vendors Preferred Choice</span></div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-2">
        <div class="w-full md:w-1/2 px-2 flex flex-col">
          <h4 class="mb-6 mt-2 text-left" :class="{'text-red-dark': preferredPhotos.length === 35}">Preferred Photos ({{ preferredPhotos.length }}/35)</h4>
          <p v-if="maxImages" class="mb-2 text-left" :class="{ 'text-red-dark': preferredPhotos.length === 35 }">You have reached your maximum allowed images</p>
          <p v-if="moveMaxImages" class="mb-2 text-left text-red-dark">If you move the rest of vendor preferred photo you will be over the limit of 35 images</p>
          <div class="border p-3 flex-grow" :class="preferredPhotos.length === 35 ? 'border-red-dark bg-red-lightest' : 'border-black bg-grey-lightest'">
            <div class="flex mb-3 border bg-white" v-for="photo in preferredPhotos" :key="photo.id">
              <img :src="photo.thumb" :alt="photo.filename" loading="lazy" class="w-24 min-h-16 h-full bg-grey-lighter object-contain" />
              <div v-if="photo.is_preferred_by_vendor === true" class="flex items-center">
                  <i class="fas fa-star fa-lg text-yellow text-center ml-4"></i>
              </div>
              <div class="p-2 flex-grow truncate text-right" :title="photo.filename">
                {{ photo.filename }}
              </div>
              <button type="button" :class="photo.is_preferred_by_vendor === true ? 'bg-yellow-light hover:bg-yellow-lighter' : 'bg-grey-light hover:bg-grey-lighter'" class="text-grey-darkest px-3" title="Remove from preferred photos" @click="photo.is_preferred = false, maxImages = false, moveMaxImages = false">
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="w-full md:w-1/2 px-2 flex flex-col">
          <div class="w-full flex flex-row mb-3">
            <div class="w-1/3">
              <h4 class="mb-2 mt-2 text-left">Other Photos</h4>
            </div>
            <div class="w-2/3 flex justify-end">
              <div>
                <button type="button" class="border text-xs py-3 px-6 bg-white text-black text-right rounded" @click="moveVendorPreferred()">
                  <i class="fas fa-arrow-left"></i> Move across all <i class="fas fa-star fa-lg text-yellow"></i> Images
                </button>
              </div>
            </div>
          </div>
          <div class="border p-3 flex-grow">
            <div class="flex mb-3 border bg-white" v-for="photo in otherPhotos" :key="photo.id">
              <button v-if="preferredPhotos.length === 35" type="button" :class="photo.is_preferred_by_vendor === true ? 'bg-yellow-light hover:bg-yellow-lighter' : 'bg-grey-light hover:bg-grey-lighter'" class=" text-grey-darkest px-3" title="Add to preferred photos" @click="maxImages = true, moveMaxImages = false">
                <i class="fas fa-arrow-left"></i>
              </button>
              <button v-else type="button" :class="photo.is_preferred_by_vendor === true ? 'bg-yellow-light hover:bg-yellow-lighter' : 'bg-grey-light hover:bg-grey-lighter'" class=" text-grey-darkest px-3" title="Add to preferred photos" @click="photo.is_preferred = true, moveMaxImages = false">
                <i class="fas fa-arrow-left"></i>
              </button>
              <div class="p-2 flex-grow truncate" :title="photo.filename">
                {{ photo.filename }}
              </div>
              <div v-if="photo.is_preferred_by_vendor === true" class="flex items-center">
                <i class="fas fa-star fa-lg text-yellow text-center mr-4"></i>
              </div>
              <img :src="photo.thumb" :alt="photo.filename" loading="lazy" class="w-24 min-h-16 h-full bg-grey-lighter object-contain" />
            </div>
          </div>
        </div>
      </div>

      <p class="mt-6" v-if="preferredPhotos.length < 35">
        You can still select {{ 35 - preferredPhotos.length }} more {{ 35 - preferredPhotos.length === 1 ? 'photo' : 'photos' }}.
      </p>
      <p class="mt-6" v-else-if="preferredPhotos.length > 35">
        Please remove {{ preferredPhotos.length - 35 }} {{ preferredPhotos.length - 35 === 1 ? 'photo' : 'photos' }} from your preferred photos list.
      </p>

      <div class="flex justify-end mt-6" v-if="preferredPhotos.length <= 35">
        <button class="bg-primary rounded px-6 py-3 text-white" @click="savePreferredPhotos">
          Save
        </button>
      </div>
    </modal>

    <modal
      v-if="downloadAssetBundleModalOpen"
      @leave="downloadAssetBundleModalOpen = false"
      :showCloseBtn="true"
    >
      <h3 class="mb-2">Download Source Material</h3>
      <p class="mb-6">Please select the assets you'd like to download below. We will send you a download link via email when your asset bundle is ready.</p>

      <h3 class="mb-2 text-sm">Quality:</h3>
      <select v-model="downloadAssetBundleForm.print_ready" class="w-1/2 border hover:border-grey-darker p-3 mb-6">
        <option :value="true">Print Ready</option>
        <option :value="false">Web Ready</option>
      </select>

      <h3 class="mb-2 text-sm">Assets:</h3>
      <div v-for="item in sourceMaterial" :key="item.id" class="mb-2">
        <input type="checkbox" :id="`ab${item.id}`" v-model="downloadAssetBundleForm.item_ids" :value="item.id" />
        <label :for="`ab${item.id}`">{{ item.name }}</label>
      </div>

      <button class="bg-primary rounded px-6 py-3 text-white mt-6" @click="downloadZip">
        <i class="fas fa-sync fa-fw fa-spin" v-if="loadingZip"></i>
        <span v-else>Request Assets</span>
      </button>
    </modal>

    <deletion-modal
      v-if="artworkApprovalItem"
      @confirmed="approveArtwork(artworkApprovalItem)"
      @leave="artworkApprovalItem = null"
      @dismissed="artworkApprovalItem = null"
      :loading="approvingArtwork"
      confirm-label="Yes, approve it.">
      <h3 class="mb-2">{{ artworkApprovalItem.name }}</h3>
      <div v-if="artworkApprovalItem.internal_type_id === 10">
        <p>
          Please note that once approved, changes to your Refined Feature page are limited to price changes only. To communicate a price change,
          please contact the Fine & Country Studio using the Contact Us form below. Changes must be requested prior to the relevant edition’s copy deadline.
          Copy deadline dates can be found <a href="https://members.fineandcountry.com/marketing-and-print-c78d2961-562e-4e38-b749-8614ae5c1530/publications-539daa4a-e853-41a7-9600-550c63a8b4c9" target="_blank" class="underline">here</a>
        </p>
        <p class="mt-2" v-if="order.estimated_edition_number !== 'TBD'">
          {{ order.address }} will appear in Refined Magazine {{ order.estimated_edition_number}}. The Estimated delivery date for this edition of the magazine is {{order.estimated_delivery_date}}.
        </p>
      </div>
      <div v-else>
        <p class="mb-3">Are you sure you wish to approve this artwork? This indicates you are ready for this item to get sent to print (If applicable).</p>
        <p>To request amends, please use the contact form at the bottom of the page.</p>
      </div>
    </deletion-modal>

    <deletion-modal
      v-if="attachmentDeleteItem"
      @confirmed="deleteAttachment(attachmentDeleteItem)"
      @leave="attachmentDeleteItem = null"
      @dismissed="attachmentDeleteItem = null"
      :loading="deletingAttachment"
      confirm-label="Yes, delete it.">
      <h3 class="mb-2">{{ attachmentDeleteItem.attachment.filename }}</h3>
      <p class="mb-3">Are you sure you want to delete this asset? This action cannot be undone.</p>
    </deletion-modal>

    <modal
      v-if="vendorApprovalModalOpen"
      @leave="vendorApprovalModalOpen = false"
      :showCloseBtn="true"
    >
      <h3 class="mb-2">Vendor Approval</h3>
      <div v-if="vendorApprovalLink">
        <p class="mb-6">You may share this link with your vendor to request source material approval.</p>
        <input type="text" v-model="vendorApprovalLink" class="p-3 border block mb-6 w-full" readonly />

        <button class="bg-primary rounded px-6 py-3 text-white" @click="vendorApprovalLink = null">
          Back
        </button>
      </div>
      <div v-else>
        <p class="mb-6">You can choose to have the system submit a branded email to your vendor on your behalf, or generate a link you can share yourself.</p>

        <div class="mb-6">
          <input type="checkbox" :id="`approvalCc`" v-model="vendorApprovalForm.cc" />
          <label :for="`approvalCc`">Copy me into the email to the vendor</label>
        </div>

        <strong class="block mb-3">Included Source Material:</strong>
        <div v-for="item in sourceMaterial" :key="item.id" class="mb-2" v-if="!(item.fulfillment_by_id === 0 && !item.required_for_artwork)">
          <input type="checkbox" :id="`approval${item.id}`" v-model="vendorApprovalForm.type" :value="item.item_id" />
          <label :for="`approval${item.id}`">{{ item.name }}</label>
        </div>

        <loader v-if="requestingVendorApproval" />
        <div v-else class="flex flex-wrap items-center mt-6">
          <button class="bg-primary rounded px-6 py-3 text-white" @click="requestVendorApproval(true)">
            Send Email
          </button>

          <span class="mx-6">or</span>

          <button class="bg-primary rounded px-6 py-3 text-white" @click="requestVendorApproval(false)">
            Generate Link
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import api from '@/http'
import http from 'axios'
import GaugeGraph from '@/components/Graphs/GaugeGraph'
import { filter, endsWith, map } from 'lodash'
import { mapActions, mapState } from 'vuex'
import DeletionModal from '@/components/Modals/DeletionModal'
import UploadDropzone from '@/components/UploadDropzone'
import moment from 'moment'
import DateTimePicker from 'vue-vanilla-datetime-picker'
export default {
  components: {
    GaugeGraph,
    DeletionModal,
    UploadDropzone,
    DateTimePicker
  },
  props: ['order'],
  data () {
    return {
      sourceMaterialConfirmed: false,
      contact: {
        help_desk: null,
        message: '',
        files: []
      },
      schedulingEhouse: null,
      ehousePhotographerTimeslots: null,
      ehousePhotographerNotes: '',
      ehouseBookingTimeslot: false,
      selectedEhouseTimeslot: null,
      confirmCancelEhouse: null,
      cancellingEhouse: false,
      schedulingAgentItem: null,
      downloadAssetsItem: null,
      fulfillingAgentItem: null,
      vendorApprovalModalOpen: false,
      requestingVendorApproval: false,
      sendingEnquiry: false,
      approvingSourceMaterial: false,
      approvingArtwork: false,
      artworkApprovalItem: null,
      loadingZip: false,
      ehouseAmendsItem: null,
      galleryIndex: 0,
      selectingPreferredPhotos: false,
      savingPreferredPhotos: false,
      attachmentDeleteItem: null,
      deletingAttachment: false,
      downloadAssetBundleForm: {
        print_ready: false,
        item_ids: []
      },
      downloadAssetBundleModalOpen: false,
      vendorApprovalForm: {
        email: true,
        cc: false,
        type: []
      },
      vendorApprovalLink: null,
      internalNotes: null,
      savingInternalNote: false,
      internalNoteForm: {
        body: '',
        show_admin: false,
        show_interviewer: false
      },
      maxImages: false,
      moveMaxImages: false,
      aiImageTags: [
        { id: 'back_garden', name: 'Back Garden' },
        { id: 'bathroom', name: 'Bathroom' },
        { id: 'bedroom', name: 'Bedroom' },
        { id: 'conservatory', name: 'Conservatory' },
        { id: 'dining_room', name: 'Dining Room' },
        { id: 'ensuite', name: 'En-Suite' },
        { id: 'front_garden', name: 'Front Garden' },
        { id: 'house_front', name: 'Front of House' },
        { id: 'hallway', name: 'Hallway' },
        { id: 'kitchen', name: 'Kitchen' },
        { id: 'landing', name: 'Landing' },
        { id: 'living_room', name: 'Living Room' },
        { id: 'master_bedroom', name: 'Master Bedroom' },
        { id: 'location', name: 'Nearby Location' },
        { id: 'outside_space', name: 'Outside Space' },
        { id: 'study', name: 'Study' },
        { id: 'toilet', name: 'Toilet' },
        { id: 'utility', name: 'Utility' }
      ]
    }
  },
  created () {
    this.getNotes()

    for (let i = 0; i < this.sourceMaterial.length; i++) {
      this.downloadAssetBundleForm.item_ids.push(this.sourceMaterial[i].id)
      if (!(this.sourceMaterial[i].fulfillment_by_id === 0 && !this.sourceMaterial[i].required_for_artwork)) {
        this.vendorApprovalForm.type.push(this.sourceMaterial[i].item_id)
      }
    }
  },
  computed: {
    ...mapState(['profile', 'selectedOffice']),
    sourceMaterial () {
      if (!this.order) {
        return []
      }
      return filter(this.order.items, (item) => item.fulfillment_type === 0)
    },
    artwork () {
      if (!this.order) {
        return []
      }
      return filter(this.order.items, (item) => item.fulfillment_type === 1)
    },
    otherItems () {
      if (!this.order) {
        return []
      }
      return filter(this.order.items, (item) => item.fulfillment_type === 2)
    },
    ehouseItems () {
      if (!this.order) {
        return []
      }
      return filter(this.order.items, (item) => item.fulfillment_by_id === 2)
    },
    hasStudioArtworkItems () {
      return filter(this.artwork, (item) => item.fulfillment_by_id === 1).length > 0
    },
    totalProgressItems () {
      let total = 0

      for (let i = 0; i < this.order.items.length; i++) {
        if (this.order.items[i].fulfillment_by_id !== null) {
          total += this.order.items[i].requires_scheduling ? 2 : 1
        }
      }

      if (this.order.payment.amount) {
        total++
      }

      return total
    },
    totalCompletedItems () {
      let total = 0

      for (let i = 0; i < this.order.items.length; i++) {
        if (this.order.items[i].fulfillment_by_id !== null) {
          if (this.order.items[i].requires_scheduling && this.order.items[i].scheduled_at) {
            total++
          }
          if (this.order.items[i].completed_at) {
            total++
          }
        }
      }

      if (this.order.payment.amount && this.order.payment.paid_at) {
        total++
      }

      return total
    },
    totalProgressPercentage () {
      return Math.round((100 / this.totalProgressItems) * this.totalCompletedItems)
    },
    assetCount () {
      let total = 0

      for (let i = 0; i < this.sourceMaterial.length; i++) {
        total += this.sourceMaterial[i].attachments.length
      }

      return total
    },
    galleryImages () {
      if (!this.downloadAssetsItem) {
        return []
      }
      return filter(this.downloadAssetsItem.attachments, (attachment) => {
        const url = attachment.url.toLowerCase()
        return endsWith(url, 'jpg') || endsWith(url, 'jpeg') || endsWith(url, 'png') || endsWith(url, 'gif')
      })
    },
    galleryFiles () {
      if (!this.downloadAssetsItem) {
        return []
      }
      return filter(this.downloadAssetsItem.attachments, (attachment) => {
        const url = attachment.url.toLowerCase()
        return !(endsWith(url, 'jpg') || endsWith(url, 'jpeg') || endsWith(url, 'png') || endsWith(url, 'gif'))
      })
    },
    photoAttachments () {
      if (!this.order) {
        return []
      }

      let output = []
      const items = filter(this.order.items, (item) => [11, 15, 16].includes(item.internal_type_id))
      for (let i = 0; i < items.length; i++) {
        for (let a = 0; a < items[i].attachments.length; a++) {
          output.push(items[i].attachments[a])
        }
      }

      return output
    },
    preferredPhotos () {
      return filter(this.photoAttachments, (attachment) => attachment.is_preferred)
    },
    vendorPreferredPhotos () {
      return filter(this.photoAttachments, (attachment) => attachment.is_preferred_by_vendor)
    },
    otherPhotos () {
      return filter(this.photoAttachments, (attachment) => !attachment.is_preferred)
    },
    hasVendorInterview () {
      if (!this.order) {
        return []
      }
      return filter(this.order.items, (item) => item.internal_type_id === 5).length > 0
    },
    showStudioOption () {
      if (!this.hasStudioArtworkItems) {
        return false
      }
      if (this.profile.type > 2) {
        if (this.order.status_id >= 6) {
          return true
        }
        return false
      }
      return true
    },
    apiUrl () {
      return process.env.VUE_APP_ROOT_API
    }
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    eHouseBookVisitInit (item) {
      this.ehousePhotographerTimeslots = null
      this.selectedEhouseTimeslot = null
      this.ehouseBookingTimeslot = false
      this.schedulingEhouse = item

      api.get(`/marketing-packs/orders/${this.order.id}/ehouse/${item.id}/photographer-availability`).then((response) => {
        this.ehousePhotographerTimeslots = response.data
      }, () => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Unable to fetch available timeslots. Try again later.'
        })
        this.schedulingEhouse = null
      })
    },
    ehouseBookPhotographer () {
      this.ehouseBookingTimeslot = true
      api.post(`/marketing-packs/orders/${this.order.id}/ehouse/${this.schedulingEhouse.id}/book-photographer`, {
        photographer_id: this.selectedEhouseTimeslot.photographerId,
        date: this.selectedEhouseTimeslot.start,
        notes: this.ehousePhotographerNotes
      }).then((response) => {
        this.schedulingEhouse = null

        for (let i = 0; i < this.ehouseItems.length; i++) {
          if (this.ehouseItems[i].ehouse_order_id === response.data.ehouse_order_id && this.ehouseItems[i].completed_at === null) {
            this.ehouseItems[i].scheduled_at = response.data.scheduled_at
            this.ehouseItems[i].status = 'awaiting_fulfillment'
            this.ehouseItems[i].can_unschedule = true
          }
        }

        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Photographer Booked',
          info: 'eHouse photographer appointment booked successfully'
        })
      }, () => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Unable to book timeslot. Try again later.'
        })
        this.ehouseBookingTimeslot = false
      })
    },
    ehouseCancelPhotographer () {
      this.cancellingEhouse = true
      api.post(`/marketing-packs/orders/${this.order.id}/ehouse/${this.confirmCancelEhouse}/unbook-photographer`).then((response) => {
        this.cancellingEhouse = false
        this.confirmCancelEhouse = null

        for (let i = 0; i < this.ehouseItems.length; i++) {
          if (this.ehouseItems[i].completed_at === null) {
            this.ehouseItems[i].scheduled_at = null
            this.ehouseItems[i].status = 'awaiting_schedule'
          }
        }

        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Appointment Cancelled',
          info: 'eHouse photographer appointment cancelled successfully'
        })
      }, () => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Unable to cancel appointment. Try again later.'
        })
        this.cancellingEhouse = false
        this.confirmCancelEhouse = null
      })
    },
    scheduleAgentItem () {
      if (!this.schedulingAgentItem.scheduled_at) {
        return
      }
      this.schedulingAgentItem.scheduled_at = moment(this.schedulingAgentItem.scheduled_at).format('YYYY-MM-DD HH:mm:ss')
      this.schedulingAgentItem.status = 'awaiting_fulfillment'

      api.post(`/marketing-packs/orders/${this.order.id}/schedule-agent-item`, {
        id: this.schedulingAgentItem.id,
        scheduled_at: this.schedulingAgentItem.scheduled_at
      }).then((response) => {
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Item Scheduled',
          info: 'Item scheduled for completion at your chosen time'
        })
      }, () => {
        this.schedulingAgentItem.scheduled_at = null
        this.schedulingAgentItem.status = 'awaiting_schedule'
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Unable to schedule item. Try again later.'
        })
      })
    },
    uploadAssets (item, files) {
      for (let i = 0; i < files.length; i++) {
        this.uploadAsset(item, files[i])
      }
    },
    async uploadAsset (item, file) {
      let attachment = {
        filename: file.name,
        size: file.size,
        progress: 0,
        complete: false
      }
      item.uploads.push(attachment)

      let filePath = `marketing-packs/${this.order.id}`

      const extension = file.name.split('.').pop()
      const response = await api.post('signed-upload', {
        'disk': 's3',
        'extension': extension,
        'path': filePath,
        'visibility': 'public-read',
        'content_type': file.type
      })

      let s3File = response.data.key
      let headers = response.data.headers
      if ('Host' in headers) {
        delete headers.Host
      }

      await http.put(response.data.url, file, {
        headers: headers,
        onUploadProgress: (progressEvent) => {
          attachment.progress = Math.ceil(progressEvent.loaded / progressEvent.total * 100)
        }
      })

      let data = {
        filePath: s3File,
        extension: s3File,
        fileName: file.name,
        id: item.id
      }

      api.post(`/marketing-packs/orders/${this.order.id}/upload-asset`, data).then((response) => {
        attachment.complete = true
        item.attachments.push(response.data.attachment)
        item.completed_at = response.data.item.completed_at
        item.status = 'complete'
        this.order.status_id = response.data.order.status_id
      }, (errors) => {
        item.uploads.splice(item.uploads.indexOf(attachment), 1)
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: errors.response.data.errors.file[0]
        })
      })
    },
    savePropertyDescription (item) {
      api.patch(`/marketing-packs/orders/${this.order.id}/items/${item.id}/description`, item.data)
        .then((response) => {
          this.fulfillingAgentItem.completed_at = response.data.item.completed_at
          this.fulfillingAgentItem = null
          this.order.status_id = response.data.status_id
        })
    },
    requestVendorApproval (email) {
      if (this.requestingVendorApproval) {
        return
      }
      this.requestingVendorApproval = true
      this.vendorApprovalForm.email = email

      api.post(`/marketing-packs/orders/${this.order.id}/request-vendor-approval`, this.vendorApprovalForm).then((response) => {
        this.requestingVendorApproval = false
        if (email) {
          this.vendorApprovalModalOpen = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check-circle',
            title: 'Approval Requested',
            info: 'An email has been sent to the vendor(s) requesting source material approval'
          })
        } else {
          this.vendorApprovalLink = response.data.url
        }
      }, () => {
        this.requestingVendorApproval = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to request vendor approval. Try again later.'
        })
      })
    },
    moveVendorPreferred () {
      let finalTotalImages = (this.preferredPhotos.length + filter(this.otherPhotos, (attachment) => attachment.is_preferred_by_vendor).length)
      if (finalTotalImages > 35) {
        this.maxImages = false
        this.moveMaxImages = true
        return
      }
      this.photoAttachments.forEach(photo => {
        if (photo.is_preferred_by_vendor === true) {
          photo.is_preferred = true
        }
      })
    },
    approveSourceMaterial () {
      if (this.approvingSourceMaterial) {
        return
      }

      this.approveSourceMaterial = true
      api.post(`/marketing-packs/orders/${this.order.id}/approve-source-material`).then((response) => {
        this.approveSourceMaterial = false
        this.order.status_id = response.data.status_id
        this.order.vendor_source_material_approved_at = response.data.vendor_source_material_approved_at
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Source Material Approved',
          info: this.selectedOffice.network_id === 7 ? 'The studio have been notified to begin the artwork.' : 'The artwork stage is now open.'
        })
      }, () => {
        this.approveSourceMaterial = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to approve source material. Try again later.'
        })
      })
    },
    approveArtwork (item) {
      if (this.approvingArtwork) {
        return
      }

      this.approvingArtwork = true
      api.post(`/marketing-packs/orders/${this.order.id}/approve-artwork/${item.id}`).then((response) => {
        this.approvingArtwork = false
        this.order.status_id = response.data.status_id
        item.approved_at = response.data.approved_at
        item.completed_at = response.data.completed_at
        this.order.edition_number = response.data.edition_number
        this.order.estimated_edition_number = response.data.estimated_edition_number
        this.order.delivery_date = response.data.delivery_date
        this.order.estimated_delivery_date = response.data.estimated_delivery_date
        this.artworkApprovalItem = false
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: item.name,
          info: 'Artwork Approved'
        })
      }, () => {
        this.approvingArtwork = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to approve artwork. Try again later.'
        })
      })
    },
    sendEnquiry () {
      if (this.sendingEnquiry) {
        return
      }

      let data = new FormData()
      data.append('help_desk', this.contact.help_desk)
      data.append('message', this.contact.message)
      for (let i = 0; i < this.contact.files.length; i++) {
        data.append(`files[${i}]`, this.contact.files[i])
      }

      this.sendingEnquiry = true
      api.post(`/marketing-packs/orders/${this.order.id}/contact`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        this.sendingEnquiry = false
        this.contact.message = ''
        this.contact.file = null
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Enquiry Received',
          info: 'We will get back to you shortly.'
        })
      }, () => {
        this.sendingEnquiry = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: 'Failed to send enquiry. Try again later.'
        })
      })
    },
    downloadZip () {
      if (this.loadingZip) {
        return
      }
      this.loadingZip = true

      api
        .post(`/marketing-packs/orders/${this.order.id}/download-assets`, this.downloadAssetBundleForm)
        .then(() => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check-circle',
            title: 'Assets Requested',
            info: "We're packaging up your selected assets and will send you a download link within an email shortly."
          })

          this.downloadAssetBundleModalOpen = false
          this.loadingZip = false
        })
        .catch((errors) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation-triangle',
            title: 'Download Failed',
            info: errors.response.data.message
          })

          this.loadingZip = false
        })
    },
    savePreferredPhotos () {
      if (this.savingPreferredPhotos) {
        return
      }
      this.savingPreferredPhotos = true

      api.patch(`/marketing-packs/orders/${this.order.id}/preferred-photos`, {
        ids: map(this.preferredPhotos, (photo) => photo.id)
      }).then(() => {
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Preferred Photos',
          info: 'Your preferred photos have been saved.'
        })
        this.savingPreferredPhotos = false
      }, (errors) => {
        this.approvingArtwork = false
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times-circle',
          title: 'Error',
          info: errors.response.data.message
        })
        this.savingPreferredPhotos = false
      })
    },
    deleteAttachment (data) {
      this.deletingAttachment = true

      api.delete(`/marketing-packs/orders/${this.order.id}/delete-asset/${data.attachment.id}`).then((response) => {
        this.attachmentDeleteItem = null
        this.deletingAttachment = false
        this.order.status_id = response.data.order.status_id
        data.item.completed_at = response.data.item.completed_at
        if (response.data.item.completed_at === null) {
          this.downloadAssetsItem = null
        }
        this.galleryIndex = Math.max(0, Math.min(this.galleryIndex, this.galleryImages.length - 2))

        data.item.attachments.splice(data.item.attachments.indexOf(data.attachment), 1)

        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Asset Deleted',
          info: 'The asset has been deleted.'
        })
      })
    },
    getNotes () {
      api.get(`/marketing-packs/orders/${this.order.id}/notes`).then((response) => {
        this.internalNotes = response.data
      })
    },
    addNote () {
      this.savingInternalNote = true
      api.post(`/marketing-packs/orders/${this.order.id}/notes`, this.internalNoteForm).then((response) => {
        this.internalNoteForm.body = ''
        this.internalNotes.splice(0, 0, response.data)
        this.savingInternalNote = false
      }, (errors) => {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-exclamation-triangle',
          title: 'Error',
          info: errors.response.data.message
        })
        this.savingInternalNote = false
      })
    },
    checkIfPrivateNote (note) {
      if (!note.show_admin && !note.show_interviewer) {
        return true
      }
      return false
    },
    deleteNote (note) {
      api.delete(`/marketing-packs/orders/${this.order.id}/notes/${note.id}`).then((response) => {
        this.internalNotes.splice(this.internalNotes.indexOf(note), 1)
      })
    },
    paymentLabel (payment) {
      if (payment.is_additional) {
        return 'Additional Payment'
      }
      if (payment.type === 'vendor') {
        return 'Vendor Payment'
      }
      return 'Agent Payment'
    },
    getDigitalHubUrl (item) {
      if (!item.mmn_order_id) {
        return null
      }

      const mmnQuery = new URLSearchParams({
        order_id: item.mmn_order_id,
        sorts: 1
      })

      const query = new URLSearchParams({
        office_id: this.order.office_id,
        redirect_url: `/order/editor?${mmnQuery}`
      })

      return `${process.env.VUE_APP_ROOT_API}/sso/market-me-now?${query}`
    },
    addDescriptionItem () {
      this.fulfillingAgentItem.data.description.push({
        tag: null,
        description: null
      })
    },
    removeDescriptionItem (item) {
      const index = this.fulfillingAgentItem.data.description.indexOf(item)
      this.fulfillingAgentItem.data.description.splice(index, 1)
    },
    moveDescriptionItemUp (item) {
      const index = this.fulfillingAgentItem.data.description.indexOf(item)
      if (index > 0) {
        this.fulfillingAgentItem.data.description.splice(index, 1)
        this.fulfillingAgentItem.data.description.splice(index - 1, 0, item)
      }
    },
    moveDescriptionItemDown (item) {
      const index = this.fulfillingAgentItem.data.description.indexOf(item)
      if (index < this.fulfillingAgentItem.data.description.length - 1) {
        this.fulfillingAgentItem.data.description.splice(index, 1)
        this.fulfillingAgentItem.data.description.splice(index + 1, 0, item)
      }
    },
    updateTag (itemId, attachment) {
      api.patch(`/marketing-packs/orders/${this.order.id}/items/${itemId}/attachments/${attachment.id}/tag`, {
        tag: attachment.tag
      })
    }
  }
}
</script>
